import usePrivateLink from "../config/usePrivateLink";
import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { BusCreate, BusDelete, BusUpdate, GetBus } from "../../api/BusService";
import { closeModal, ToastMain ,SweetAlertShow} from "../master/Master";
import Swal from "sweetalert2";
import BusHeader from "./BusHeader";

export default function Bus() {
  const hasAccess = usePrivateLink();
  const [loading, setLoading] = useState(false);
  const [buses, setBuses] = useState([]);
  const [modalData, setModalData] = useState("");
  const[error, setError]=useState('')

  const busList = async () => {
    setLoading(true);
    try {
      const response = await GetBus();
      if (response.data.status) {
        setBuses(response.data.data || []);
      } else {
        SweetAlertShow('info','Warning',response?.data?.message)
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });
      }
    } catch (error) {
      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });
    } finally {
      setLoading(false);
    }
  };
  const newBus = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await BusCreate(formData);
      if (response.data.status) {
        setError('')
        closeModal("AddBus")
        busList();
        SweetAlertShow('success','Successfully',response?.data?.message)
        // ToastMain.fire({
        //   icon: "success",
        //   title: "Created Successfully!",
        // })
        e.target.reset();
      } else {
        if(response?.data?.errors){
          setError(response?.data?.errors)
        }
        SweetAlertShow('info','Warning',response?.data?.message)
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });
      }
    } catch (error) {
      if(error?.response?.data?.errors){
        setError(error?.response?.data?.errors)
      }
      SweetAlertShow('error','Error',error?.response?.data?.message ??  error?.response?.message ?? error?.message)
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });
    } finally {
      setLoading(false);
    }
  };

  const updateBus = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await BusUpdate(formData);
      if (response.data.status) {
        setError('')
        closeModal("UpdateBus")
        busList();
        SweetAlertShow('success','Successfully',response?.data?.message)
        // ToastMain.fire({
        //   icon: "success",
        //   title: "Update Successfully!",
        // })
      } else {
        if(response?.data?.errors){
          setError(response?.data?.errors)
        }
        SweetAlertShow('info','Warning',response?.data?.message)
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });
      }
    } catch (error) {
      if(error?.response?.data?.errors){
        setError(error?.response?.data?.errors)
      }
      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });
    } finally {
      setLoading(false);
    }
  };

  const deleteBus = async (id) => {
    setLoading(true);
    try {
      const response = await BusDelete(id);
      if (response.data.status) {
        busList();
        ToastMain.fire({
          icon: "success",
          title: "Delete Successfully!",
        }).then(() => {
          busList();
        });
      } else {
        SweetAlertShow('info','Warning', response?.data?.message)
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });
      }
    } catch (error) {
      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    busList();
  }, []);
return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid mt-2">
             
              <div className="row">
                <div className="d-flex gap-2">
                  <div className="col-md-3">
                  <BusHeader/>
                  </div>
                  <div className="col-md-9">
                      <div className="card">
                  <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between">
                      <h4 className="text-primary">Buses</h4>
                      {hasAccess('/bus/add') && (
                        <button
                          className="btn btn-primary d-inline-flex align-items-center overflow-hidden  transition-button"
                          data-bs-toggle="modal"
                          data-bs-target="#AddBus"
                        >
                          <span className="icon">
                            <i className="bi bi-plus-circle-dotted"></i>
                          </span>
                          <span className="text ms-1">New Bus</span>
                        </button>
                      )}
                    </div>
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead className="table">
                          <tr>
                            <th>#</th>
                            <th>Bus Number</th>
                            <th>Driver Name</th>
                            <th>Capacity</th>
                            <th>Driver Number</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {buses.map((bus, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{bus.bus_number}</td>
                              <td>{bus.driver_name}</td>
                              <td>{bus.capacity}</td>
                              <td>{bus.driver_number}</td>
                              <td className="d-flex gap-2">
                                {hasAccess('/bus/update') && (
                                  <button
                                    className="btn btn-sm btn-outline-primary px-2 py-1"
                                    onClick={() => setModalData(bus)}
                                    data-bs-toggle="modal"
                                    data-bs-target="#UpdateBus"
                                  >
                                    <i className="bi bi-pencil-square"></i>
                                  </button>
                                )}
                                {hasAccess('/bus/delete') && (


                                  <button
                                    className="btn btn-sm btn-outline-danger px-2 py-1"
                                    onClick={() =>
                                      Swal.fire({
                                        title: "Are you sure?",
                                        text: "This action will permanently delete the Batch!",
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonColor: "#d33",
                                        cancelButtonColor: "#6c757d",
                                        confirmButtonText: "Yes, delete it!",
                                        cancelButtonText: "Cancel",
                                      }).then(async (result) => {
                                        if (result.isConfirmed) {
                                          deleteBus(bus.id);
                                        }
                                      })
                                    }
                                  >
                                    <i className="bi bi-trash-fill"></i>
                                  </button>

                                )}

                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="AddBus"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <form onSubmit={newBus}>
              <div className="modal-header bg-label-primary p-4">
                <h1 className="modal-title fs-5 " id="exampleModalLabel">
                  Add New Bus
                </h1>
                <button
                  type="button"
                  className="btn-close "
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="mb-3 form-floating form-floating-outline mb-5 fv-plugins-icon-container">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter bus number RJ01XX1234"
                    required
                    name="bus_number"
                    pattern="^[A-Z]{2}\d{2}[A-Z]{2}\d{4}$"
                    onChange={(e) => {
                      const value = e.target.value.toUpperCase();
                      e.target.value = value;
                    }}
                  />
                  <label>Bus Number</label>
                  <span className="text-danger">{error?.bus_number ?? ''}</span>
                </div>
                <div className="mb-3 form-floating form-floating-outline mb-5 fv-plugins-icon-container">
                  <input
                    type="text"
                    className="form-control input-uppercase"
                    placeholder="Enter driver name"
                    name="driver_name"
                    onChange={(e) => {
                      const value = e.target.value.toUpperCase();
                      e.target.value = value;
                    }}
                    required
                  />
                  <label>Driver Name</label>
                   <span className="text-danger">{error?.driver_name ?? ''}</span>
                </div>
                <div className="mb-3 form-floating form-floating-outline mb-5 fv-plugins-icon-container">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter driver number"
                    name="driver_number"
                    maxLength={10}
                    minLength={10}
                    pattern="\d{10}"
                    title="Please enter exactly 10 digits"
                    required
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                  />
                  <label>Driver Number</label>
                   <span className="text-danger">{error?.driver_number ?? ''}</span>
                </div>
                <div className="mb-3 form-floating form-floating-outline mb-5 fv-plugins-icon-container">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter capacity"
                    name="capacity"
                  />
                  <label>Capacity</label>
                   <span className="text-danger">{error?.capacity ?? ''}</span>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                 <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}  // Disable the button while loading
                >
                  {loading ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  ) : (
                    'Submit'
                  )}
                  {loading ? ' Submitting...' : ''}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="UpdateBus"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <form onSubmit={updateBus}>
              <div className="modal-header bg-label-primary p-4">
                <h1 className="modal-title fs-5 " id="exampleModalLabel">
                  Update Bus
                </h1>
                <button
                  type="button"
                  className="btn-close "
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <input
                  type="hidden"
                  className="form-control"
                  placeholder="Enter bus number RJ01XX1234"
                  required
                  name="id"
                  value={modalData?.id}
                />
                <div className="mb-3 form-floating form-floating-outline mb-5 fv-plugins-icon-container">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter bus number RJ01XX1234"
                    required
                    name="bus_number"
                    pattern="^[A-Z]{2}\d{2}[A-Z]{2}\d{4}$"
                    onChange={(e) => {
                      const value = e.target.value.toUpperCase();
                      e.target.value = value;
                    }}
                    defaultValue={modalData?.bus_number}
                  />
                  <label>Bus Number</label>
                   <span className="text-danger">{error?.bus_number ?? ''}</span>
                </div>
                <div className="mb-3 form-floating form-floating-outline mb-5 fv-plugins-icon-container">
                  <input
                    type="text"
                    className="form-control input-uppercase"
                    placeholder="Enter driver name"
                    name="driver_name"
                    onChange={(e) => {
                      const value = e.target.value.toUpperCase();
                      e.target.value = value;
                    }}
                    required
                    defaultValue={modalData?.driver_name}
                  />
                  <label>Driver Name</label>
                  <span className="text-danger">{error?.driver_name ?? ''}</span>
                </div>
                <div className="mb-3 form-floating form-floating-outline mb-5 fv-plugins-icon-container">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter driver number"
                    name="driver_number"
                    maxLength={10}
                    minLength={10}
                    pattern="\d{10}"
                    title="Please enter exactly 10 digits"
                    required
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                    defaultValue={modalData?.driver_number}
                  />
                  <label>Driver Number</label>
                   <span className="text-danger">{error?.driver_number ?? ''}</span>
                </div>
                <div className="mb-3 form-floating form-floating-outline mb-5 fv-plugins-icon-container">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter capacity"
                    name="capacity"
                    defaultValue={modalData?.capacity}
                  />
                  <label>Capacity</label>
                  <span className="text-danger">{error?.capacity ?? ''}</span>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                    <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}  // Disable the button while loading
                >
                  {loading ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  ) : (
                    'Submit'
                  )}
                  {loading ? ' Submitting...' : ''}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
